import { FC, ReactElement, useCallback, useMemo } from 'react';

import { useMedia } from '../../../hooks/useMedia';
import { useCoreDispatch } from '../../../store/CoreStore';
import { useConfigSlice } from '../../../store/slices/config/selectors';
import { popupActions } from '../../../store/slices/popup/slice';
import { redirectParentIframe } from '../../../utils/redirect';
import { ButtonVariant } from '../../controls/button/Button';
import { PopupType } from '../types';

import { BlockingModalActionButton, BlockingModalContent } from './BlockingModalContent';

export const PlayerLimitConnected: FC = (): ReactElement => {
  const casinoConfig = useConfigSlice.casinoConfig();
  const dispatch = useCoreDispatch();
  const isTouch = useMedia('(pointer: coarse)');

  // For touch (mobile) devices, redirect to mobile site version with fallback to desktop version. Otherwise, default to operator's desktop site version.
  const redirectUrl = useMemo(() => {
    return isTouch ? casinoConfig?.exitUrl ?? casinoConfig?.homeUrl : casinoConfig?.homeUrl;
  }, [isTouch, casinoConfig]);

  const handleClick = useCallback((): void => {
    dispatch(popupActions.dismissPopup(PopupType.PlayerLimit));

    if (!redirectUrl) return;

    redirectParentIframe(redirectUrl);
  }, [dispatch, redirectUrl]);

  const action: BlockingModalActionButton[] = [
    {
      tk: 'OK',
      type: ButtonVariant.ACCENT,
      click: handleClick,
    },
  ];

  return <BlockingModalContent messageTk="ERROR_20610" actions={action} />;
};
